import React from 'react';
import PersonalMenuContent from "./personal-menu-content";
import withAuth from '../../../hooks/with-auth';


const PersonalMenu = React.forwardRef((props, ref) => {
    return (props.isLocal ? <PersonalMenuContent /> : null);
});

export default withAuth(PersonalMenu);